import React, { ComponentType } from 'react';
import Logo from 'components/common/Logo';
import TrustpilotStars from 'components/common/TrustpilotStars';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import PaddingBox from '@uds/padding-box';
import { Container } from '@uds/grid';
import { Heading06 } from '@uds/typography';
import errorBoundary from 'presentation/hocs/errorBoundary';
import getLocalizedTrustPilotUrl from 'presentation/utils/getTrustpilotUrl';
import { RibbonProps, Type } from 'domain/constants/ribbons';
import visibilitySet from 'presentation/hocs/visibilitySet';
import { useBrandConfig, useLocale } from '@ux/whitelabel';

import { ReviewProps } from './Review';
import getClassNames from './AdvocateTrustpilot.stylesheet';
import Ribbon from '../Ribbon';
import Reviews from './Reviews';

export interface OuterProps extends RibbonProps {
  numberOfReviews?: {
    total: number;
    usedForTrustScoreCalculation: number;
    oneStar: number;
    twoStars: number;
    threeStars: number;
    fourStars: number;
    fiveStars: number;
  };
  stars: string;
  trustScore: number;
  reviews: Array<ReviewProps>;
}

export const AdvocateTrustpilot = ({
  id,
  colorway,
  loading,
  layout,
  name,
  stars,
  trustScore,
  reviews,
  numberOfReviews,
}: OuterProps) => {
  const brandConfig = useBrandConfig();
  const trustpilotPageId = brandConfig?.trustPilot?.pageId;
  const currentLanguage = useLocale();
  const url = getLocalizedTrustPilotUrl(currentLanguage, trustpilotPageId);
  const reviewCount = numberOfReviews?.total ?? null;
  const classNames = getClassNames();
  return (
    <Ribbon colorway={colorway} loading={loading} layout={layout} name={name} id={id} type={Type.ADVOCATE_TRUST_PILOT}>
      <Container>
        <PaddingBox className={classNames.inner}>
          <div className={classNames.logo}>
            <Logo colorway={colorway} url={url} />
          </div>
          <div className={classNames.stars}>
            <TrustpilotStars rating={stars} />
          </div>
          <Heading06 className={classNames.title} component="p">
            <FormattedMessage
              id="usf.ribbons.advocate.trustpilot.title"
              values={{
                stars,
                trustScore: <FormattedNumber value={trustScore} />,
                reviewCount: <FormattedNumber value={reviewCount!} />,
              }}
            />
          </Heading06>
        </PaddingBox>
        <Reviews reviews={reviews} />
      </Container>
    </Ribbon>
  );
};

AdvocateTrustpilot.displayName = 'AdvocateTrustpilot';

export default errorBoundary(visibilitySet(AdvocateTrustpilot)) as ComponentType<OuterProps>;
